import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/responsive.css';
import App from './app';

ReactDOM.render(<App />, document.getElementById('root'));